require("@rails/ujs").start()
import * as Turbo from "@hotwired/turbo"
import { cable } from "@hotwired/turbo-rails"
import consumer from "./channels/consumer"
cable.setConsumer(consumer)
import "./lib/choices_lib.js"
import "./controllers"
import tippy from 'tippy.js';
//Turbo.session.drive = false

import Prism from "./lib/prism.js";
import '@material/mwc-circular-progress';

import TomSelect from 'tom-select';

// Shared function to initialize tippy only on elements with non-empty content
function initializeTippy(container = document) {
  const tooltipElements = [];

  if (container instanceof Element && container.matches('[data-tippy-content]')) {
    tooltipElements.push(container);
  }

  tooltipElements.push(...container.querySelectorAll('[data-tippy-content]'));

  const newTooltipElements = [];
  tooltipElements.forEach((element) => {
    const nextContent = element.getAttribute('data-tippy-content') || '';

    if (element._tippy) {
      // Keep existing instances in sync when Turbo updates attributes/content.
      if (element._tippy.props.content !== nextContent) {
        element._tippy.setContent(nextContent);
      }
      return;
    }

    newTooltipElements.push(element);
  });

  if (newTooltipElements.length > 0) {
    tippy(newTooltipElements);
  }
}

// To add tooltips to elements with data-overflow-tooltip only when text overflows
// So that we don't need to do this every time we need to show a tooltip for truncated texts
// Just need to add data-overflow-tooltip="<%= text %>" attribute to the element we want to show a tooltip for
function initializeOverflowTooltips(container = document) {
  const elements = container.querySelectorAll('[data-overflow-tooltip]');
  elements.forEach(element => {
    // Destroy existing tooltip if any
    if (element._tippy) {
      element._tippy.destroy();
    }
    element.removeAttribute('data-tippy-content');

    // Check if text is overflowing
    if (element.scrollWidth > element.clientWidth) {
      const tooltipText = element.dataset.overflowTooltip;
      if (tooltipText) {
        element.setAttribute('data-tippy-content', tooltipText);
      }
    }
  });

  // Initialize tippy for elements that have the attribute
  tippy(container.querySelectorAll('[data-overflow-tooltip][data-tippy-content]'));
}

// Make it available globally
window.initializeTippy = initializeTippy;
window.initializeOverflowTooltips = initializeOverflowTooltips;

function updateMacShortcuts() {
  if (navigator.userAgent.includes('Macintosh')) {
    const metaElements = document.querySelectorAll('.keyboard-shortcuts__shortcut--meta')
    metaElements.forEach(element => {
      element.innerHTML = '⌘'
    })
    const optionsElements = document.querySelectorAll('.keyboard-shortcuts__shortcut--options')
    optionsElements.forEach(element => {
      element.innerHTML = 'OPTION'
    })
  }
}

function mountGlobalScripts() {
  // Initialize tippy only on elements with non-empty content
  initializeTippy();
  
  // Initialize overflow tooltips (only show when text truncated)
  initializeOverflowTooltips();

  window.Prism = window.Prism || {};
  window.Prism.manual = true;
  Prism.highlightAll();

  updateMacShortcuts();

  if (document.querySelector(".js-choice")) {
    new TomSelect(".js-choice", {
      create: true,
      sortField: {
        field: "text",
        direction: "asc"
      }
    });
  }
}

// The following prevents the CSRF token from being reset on every Turbo visit
// You can test this by searching in the new datagrid, then trying to turn on dark mode/off dark mode.
// without this - it always results in a 422 error
function getCsrfToken() {
  return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
}

function setCsrfToken(token) {
  var meta = document.createElement('meta');
  meta.name = "csrf-token";
  meta.content = "";
  if (!document.querySelector('meta[name="csrf-token"]')) {
    document.getElementsByTagName('head')[0].appendChild(meta);
    document.querySelector('meta[name="csrf-token"]').setAttribute('content', token);
  }
}

// Turbo's ErrorRenderer replaces the entire <head> on non-2xx responses, which
// re-evaluates all scripts and creates duplicate Stimulus instances. Known Bug.
// https://github.com/hotwired/turbo/issues/1190
document.addEventListener('turbo:before-fetch-response', (event) => {
  const { status, url } = event.detail.fetchResponse.response
  // Guard on tagName === "HTML" to skip prefetch requests and frame loads.
  if (event.target.tagName === 'HTML' && status >= 400) {
    event.preventDefault()
    // Force a full page reload instead of a turbo visit
    window.location.href = url
  }
})

document.addEventListener('turbo:before-fetch-request', function (event) {
  var currentCsrfToken = getCsrfToken();
  event.detail.fetchOptions.headers['X-CSRF-Token'] = currentCsrfToken;
  localStorage.setItem('previousCsrfToken', currentCsrfToken);
});

document.addEventListener('turbo:load', () => {
  mountGlobalScripts();
  var previousCsrfToken = localStorage.getItem('previousCsrfToken');
  if (previousCsrfToken) {
    setCsrfToken(previousCsrfToken);
  }
})

document.addEventListener('DOMContentLoaded', () => {
  mountGlobalScripts();
})

// Add new event listener for Turbo Frame loads
document.addEventListener('turbo:frame-load', (event) => {
  updateMacShortcuts();
  const frame = event.target instanceof Element ? event.target : document;
  initializeOverflowTooltips(frame);
});

// Re-initialize tooltips after Turbo Stream DOM updates.
document.addEventListener('turbo:before-stream-render', (event) => {
  const originalRender = event.detail.render;
  event.detail.render = (streamElement) => {
    originalRender(streamElement);

    // Scope tooltip work to stream targets to avoid scanning whole document.
    const targetElements = streamElement.targetElements || [];
    if (targetElements.length === 0) return;

    targetElements.forEach((targetElement) => {
      if (!(targetElement instanceof Element)) return;
      initializeTippy(targetElement);
      initializeOverflowTooltips(targetElement);
    });
  };
});

